var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('KIcon',{attrs:{"icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }